import { Column, Divider, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { C1Text, C3Text } from "../../../common/components/text/CustomText";
import CustomSegmentedControl from "../../../common/components/button/CustomSegmentedControl";
import PeakAreaChart from "../../../common/components/chart/PeakAreaChart";
import { useEffect, useState } from "react";
import StoreThumbnail from "../../../common/components/image/StoreThumbnail";
import Translate from "../../../common/translate/Translate";
import { Theme } from "../../../common/Theme";
import DashboardService from "../../../service/DashboardService";
import { format } from "date-fns";

const typeValues = [
    { label: "Top", value: "top" },
    { label: "Lowest", value: "lowest" },
];

const RANK_COUNT = 5;

function RankCard() {
    const service = new DashboardService();
    const [selectedTopShopType, setSelectedTopShopType] = useState("top");
    const [shopList, setShopList] = useState([]);

    // 04.01.02.14: GET /franchises/stores/top-ten-shops — contact(금일매출금액), imgeUrl(오타 필드)
    const fetchTopTenShops = () => {
        const today = format(new Date(), "yyyy-MM-dd");
        service
            .getTopTenShops({ today })
            .then((result) => {
                const mapped = (Array.isArray(result) ? result : []).map((item) => ({
                    shopName: item.storeName ?? "",
                    thumbnail: item.imgeUrl ?? item.imageUrl ?? "",
                    revenue: Number(item.contact) || 0,
                }));
                setShopList(mapped);
            })
            .catch((error) => {
                console.error("Error fetching top ten shops:", error);
            });
    };

    useEffect(() => {
        fetchTopTenShops();
    }, []);

    // 응답의 ranking 은 매출 순서와 일치하지 않아 매출액(contact) 기준으로 다시 정렬
    const sortedShops = [...shopList].sort((a, b) =>
        selectedTopShopType === "lowest" ? a.revenue - b.revenue : b.revenue - a.revenue
    );
    const rankedShops = sortedShops.slice(0, RANK_COUNT);
    const chartData = rankedShops.map((shop, index) => ({ name: String(index + 1), value: shop.revenue }));

    return (
        <SizedBox
            height={"100%"}
            border={`1px solid ${Theme.color.neutral200}`}
            width={"100%"}
            borderRadius={"10px"}
            padding={"20px 20px"}
        >
            <Column width={"100%"} justifyContent={"flex-start"} alignItem={"flex-start"}>
                <Row width={"100%"} justifyContent={"space-between"} alignItem={"flex-start"}>
                    <C1Text>Top {RANK_COUNT} Sales Shops</C1Text>
                    <CustomSegmentedControl
                        values={typeValues}
                        currentValue={selectedTopShopType}
                        setValue={setSelectedTopShopType}
                    />
                </Row>
                <SizedBox height={"20px"} />
                <Row width={"100%"} justifyContent={"space-between"} alignItem={"flex-start"}>
                    <PeakAreaChart data={chartData} />
                    <Column width={"50%"} justifyContent={"center"} alignItem={"flex-start"}>
                        {rankedShops.length === 0 ? (
                            <Row width={"100%"} justifyContent={"center"}>
                                <C3Text fontColor={Theme.color.gray500}>
                                    {Translate("revenue.noAggregatedShops")}
                                </C3Text>
                            </Row>
                        ) : (
                            rankedShops.map((shop, index) => (
                                <RankListCard
                                    key={`${shop.shopName}-${index}`}
                                    isLast={index === rankedShops.length - 1}
                                    rank={index + 1}
                                    image={shop.thumbnail}
                                    shopName={shop.shopName}
                                    revenue={`฿${shop.revenue.toLocaleString()}`}
                                />
                            ))
                        )}
                    </Column>
                </Row>
            </Column>
        </SizedBox>
    );
}

function RankListCard({ isLast = false, rank, image, shopName, revenue }) {
    return (
        <>
            <Row width={"100%"} justifyContent={"space-between"} alignItem={"center"}>
                <Row width={"70%"}>
                    <C1Text fontWeight={"700"}>{rank}</C1Text>
                    <SizedBox width={"16px"} />
                    <StoreThumbnail src={image} size={"40px"} />
                    <SizedBox width={"12px"} />
                    <C3Text fontWeight={"400"} width={"70%"}>
                        {shopName}
                    </C3Text>
                </Row>
                <Row width={"30%"} justifyContent={"flex-end"}>
                    <C1Text fontWeight={"700"}>{revenue}</C1Text>
                </Row>
            </Row>
            {!isLast && <Divider marginTop={"18px"} marginBottom={"12px"} />}
        </>
    );
}

export default RankCard;
